import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';

// @ts-expect-error No types
import CodeMirror from 'ContentComponents/codeMirror/CodeMirror';
import { jsx as _jsx } from "react/jsx-runtime";
class Html extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  onChange({
    value
  }) {
    const {
      onFieldChange = emptyFunction
    } = this.props;
    onFieldChange(value);
  }
  render() {
    const {
      codeMirrorProps,
      readOnly,
      useOnDark,
      value = ''
    } = this.props;
    return /*#__PURE__*/_jsx(CodeMirror, Object.assign({
      className: 'cmv2-html-field' + (useOnDark ? " gypsum-background-dark" : ""),
      readOnly: readOnly,
      mode: "htmlmixed",
      onChange: this.onChange,
      value: value
    }, codeMirrorProps));
  }
}
export default Html;